import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Gender } from 'ha/types/Gender';
import { User } from './types/User';
import { APIV2_URL } from './constants';

export interface Payload {
  firstName: string;
  lastName?: string;
  email: string;
  password?: string;
  password2?: string;
  phone: string;
  phoneCountryCode: string;
  nationality: string;
  gender?: Gender;
  study?: string;
  work?: string;
  description?: string;
  location?: string;
  smoker?: string;
  enableSMSNotifications?: boolean;
  spokenLanguages?: string;
  lang?: string;
  notificationLang?: string;
  birthDay?: number;
  birthMonth?: number;
  birthYear?: number;
}

const register = (makeCall: MakeCall) => (data: Payload) =>
  makeCall<User>('POST', `${APIV2_URL}/user`, { data });

export default register;
